// extracted by mini-css-extract-plugin
module.exports = {"variables":"\"../../../../../assets/stylesheets/variables.scss\"","slateColor":"#555555","button":"FullscreenButton_button__1-BJ6","text":"FullscreenButton_text__398eD"};